module.exports = __webpack_public_path__ + "static/cloudformation-templates-61db618be4084476960e68343d391790.png";